export default function FAQAccordion({ items }) {
  return (
    <div className="space-y-4">
      {items.map((item) => (
        <details key={item.question} className="surface-panel card-lift p-5">
          <summary className="cursor-pointer list-none font-display text-xl font-extrabold text-ink">
            {item.question}
          </summary>
          <p className="mt-4 text-base leading-7 text-slate-600">{item.answer}</p>
        </details>
      ))}
    </div>
  );
}
